var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusCircleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.219 8.508v.422c0 .232-.19.422-.422.422H9.352v3.445c0 .232-.19.422-.422.422h-.422a.423.423 0 01-.422-.422V9.352H4.64a.423.423 0 01-.422-.422v-.422c0-.232.19-.422.422-.422h3.445V4.64c0-.232.19-.422.422-.422h.422c.232 0 .422.19.422.422v3.445h3.445c.232 0 .422.19.422.422zm4.219.21a8.717 8.717 0 01-8.72 8.72A8.717 8.717 0 010 8.717 8.717 8.717 0 018.719 0a8.717 8.717 0 018.719 8.719zm-1.125 0c0-4.214-3.421-7.593-7.594-7.593-4.215 0-7.594 3.42-7.594 7.594 0 4.215 3.42 7.594 7.594 7.594 4.215 0 7.594-3.421 7.594-7.594z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/plus-circle-white.b671683e5dc4c3ee45c565a057a9650e.svg";
export { SvgPlusCircleWhite as ReactComponent };